export const rawSlateComponentToDto = (rawSlateComponent) => {
    return Object.assign(Object.assign({}, rawSlateComponent), { props: rawSlateComponent.props && Object.keys(rawSlateComponent.props).length > 0
            ? JSON.stringify(rawSlateComponent.props)
            : undefined, children: rawSlateComponent.children && rawSlateComponent.children.length > 0
            ? JSON.stringify(rawSlateComponent.children)
            : undefined, output: rawSlateComponent.output &&
            Object.keys(rawSlateComponent.output).length > 0
            ? JSON.stringify(rawSlateComponent.output)
            : undefined });
};
export const slateComponentToRaw = (slateComponent) => {
    return Object.assign(Object.assign({}, slateComponent), { props: slateComponent.props ? JSON.parse(slateComponent.props) : undefined, children: slateComponent.children
            ? JSON.parse(slateComponent.children)
            : undefined, output: slateComponent.output
            ? JSON.parse(slateComponent.output)
            : undefined });
};
export const rawSlateToDto = (rawSlate) => {
    return Object.assign(Object.assign({}, rawSlate), { components: rawSlate.components.map(c => rawSlateComponentToDto(c)) });
};
export const slateToRaw = (slate) => {
    return Object.assign(Object.assign({}, slate), { components: slate.components.map(c => slateComponentToRaw(c)) });
};
//# sourceMappingURL=dto.utils.js.map